<template>
    <section class="motor-banner" v-lazy:background-image.container="bgimg">
        <div class="motor-container" :class="{start: start}">
            <h1>
                <div v-if="title">{{title}}</div>
                <div v-if="sub_title">{{sub_title}}</div>
            </h1>
        </div>
    </section>
</template>

<script>
export default {
    name: 'motor-banner',
    props: {
        bgimg: Object,
        title: String,
        sub_title: String,
        start: Boolean,
    }
}
</script>

<style lang="scss" scoped>
.motor-banner {
    width: 100%;
    height: 400px;
    max-height: 80vh;
    background-color: var(--primary);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    @media (min-width: 768px) {
        height: 600px;
    }
    .motor-container {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        padding: 40px 0;
        text-align: right;
        &.start {
            justify-content: flex-start;
            text-align: left;
        }
        h1 {
            color: #fff;
            font-weight: 900;
            font-size: 2.5rem;
            font-size: 2rem;
            padding: 20px;
            text-transform: uppercase;
            text-shadow: 0 2px 2px #333;
            @media (min-width: 768px) {
                padding: 40px 20px;
                font-size: 5rem;
            }
        }
    }
}
</style>
